import React from "react";

import { RenderAST } from "@/mk2/components/RenderAST";
import { ShowPhotosAndVideos, isASTEmpty } from "@/mk2/helpers/article_ast/filters";
import { ContentItemEntity } from "@/mk2/schemas";

import styles from "./CheckboxHelp.mscss";

interface OwnProps {
    help: ContentItemEntity;
}

type Props = OwnProps;

export const CheckboxHelp: React.FunctionComponent<Props> = ({ help }) => {
    if (isASTEmpty(help.contentAST)) {
        return null;
    }

    return (
        <div className={styles.CheckboxHelp}>
            <RenderAST
                contentAST={help.contentAST}
                linkedObjects={help.contentASTAdditionalData.linkedObjects}
                showPhotosAndVideos={ShowPhotosAndVideos.ALL}
                renderSpecialWikiLinks={false}
                customStyles={{
                    paragraph: styles.CheckboxHelp__paragraph,
                    youtube: styles.CheckboxHelp__youtube,
                }}
            />
        </div>
    );
};

CheckboxHelp.displayName = "CheckboxHelp";
